import { getAxios } from '@smg-real-estate/hg-networking';

import { DEFAULT_AGENCY_PAGE_LIST_SIZE } from '@/api/customerMetaApi';
import type { AgentProfile, AgentService, AgentSpecialization } from '@/types/agentProfile';

const axios = getAxios({
  baseURL: `${import.meta.env.VUE_APP_AGENCY_META_API_URL}/`,
  headers: { 'Content-Type': 'application/json' },
});

interface AxiosAgentsResponse {
  data: {
    from: number;
    size: number;
    total: number;
    records: AgentProfile[];
  };
}

/**
 * Client-side request for `POST /agents/search` (`SearchPublicAgentsRequest`).
 * `geoLocationIds` are mapped to `location.geoTags`.
 */
export interface AgentSearchRequest {
  from?: number;
  size?: number;
  geoLocationIds?: string[];
  facets?: {
    services?: AgentService[];
    specializations?: AgentSpecialization[];
  };
}

/** Wire format sent to `POST /agents/search`. */
export interface SearchPublicAgentsRequestBody {
  from: number;
  size: number;
  location: {
    geoTags?: string[];
  };
  facets?: AgentSearchRequest['facets'];
}

export type PaginatedAgentsResponse = AxiosAgentsResponse['data'];

export async function fetchAgents(request: AgentSearchRequest): Promise<PaginatedAgentsResponse> {
  const DEFAULT_FROM = 0;
  const data: SearchPublicAgentsRequestBody = {
    from: request.from ?? DEFAULT_FROM,
    size: request.size ?? DEFAULT_AGENCY_PAGE_LIST_SIZE,
    location: { geoTags: request.geoLocationIds },
    ...(request.facets ? { facets: request.facets } : {}),
  };

  const response = await axios.post<AxiosAgentsResponse>('/agents/search', data);

  return response.data.data;
}
